type DialogAlert = (
  title: string,
  message: string,
  callback: (btnObj: { btnPressed: string }) => void,
  buttons: string[],
) => void; // function to show the dialog alert
export const dialogOnClose =
  (dialogAlert: DialogAlert, closing?: () => void, cleanup?: () => void) =>
  (confirmIfDirty: boolean, forceClose: boolean) => {
    const close = () => {
      cleanup?.();
      closing?.();
    };

    if (forceClose || !confirmIfDirty) {
      close();
      return;
    }

    dialogAlert(
      'Just checking...',
      'Are you sure you want to discard all changes?',
      (btnObj: { btnPressed: string }) => {
        if (btnObj.btnPressed === 'Discard') {
          close();
        }
      },
      ['Go Back', 'Discard'],
    );
  };
